let action:{id:string;at:number}|undefined;
export function beginAuditAction(){action={id:crypto.randomUUID(),at:Date.now()};return action.id;}
export function currentAuditAction(){return action&&Date.now()-action.at<15000?action.id:undefined;}
